import type { Language } from "@app/constants";

interface Messages {
	header: string;
	errors: {
		fieldsRequired: string;
		generic: string;
	};

	krakenId: string;
	krakenApiKey: string;
	krakenApiSecret: string;

	submit: string;

	footer: string;
}

type Message = {
	[key in Language]: Messages;
};

const messages: Message = {
	en: {
		header: "Link Kraken Account",
		errors: {
			fieldsRequired: "Please complete the required fields highlighted in red",
			generic: "There are errors in your submission. Please see above.",
		},

		krakenId: "Kraken Account ID",
		krakenApiKey: "Kraken API Key",
		krakenApiSecret: "Kraken API Secret",

		submit: "Link Account",

		footer:
			"For help on how to setup your Kraken account, please see our <a href='https://futureforex.co.za/faq/#kraken-account-setup' target='_blank'>Kraken Setup Guide</a>.",
	},
};

export default messages;
